import { useState } from "react";
import { Loader2, CheckCircle2, BellRing } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { NOTIFY_PROFILS } from "../data/content";

const inputCls =
  "w-full rounded-xl border border-white/10 bg-navy px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold";

export default function NotifyForm() {
  const empty = { nom: "", email: "", telephone: "", profil: NOTIFY_PROFILS[0], message: "", consentement: false };
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    const hp = e.target.hp?.value || "";
    if (!f.consentement) return toast.error("Merci d'accepter d'être recontacté.");
    setBusy(true);
    try { const r = await api.notify({ ...f, hp }); setDone(r.reference); }
    catch (err) { toast.error("Une erreur est survenue."); } finally { setBusy(false); }
  };

  if (done) return (
    <div data-testid="notify-success" className="rounded-2xl border border-gold/25 bg-navy p-6 text-center">
      <CheckCircle2 className="mx-auto h-10 w-10 text-gold" strokeWidth={1.3} />
      <p className="mt-3 text-white">Votre demande a bien été enregistrée.</p>
      <p className="mt-1 text-sm text-slate-400">Nous vous informerons de l'ouverture de l'application.</p>
      <p className="mt-3 inline-block rounded-full border border-gold/40 px-4 py-1.5 font-mono text-xs text-gold">Réf. {done}</p>
    </div>
  );

  return (
    <form onSubmit={submit} data-testid="notify-form" className="rounded-2xl border border-white/10 bg-navy/60 p-6 text-left">
      <input type="text" name="hp" defaultValue="" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" />
      <div className="mb-3 flex items-center gap-2 text-gold"><BellRing className="h-4 w-4" /><span className="text-sm font-semibold">Être informé de l'ouverture</span></div>
      <div className="grid gap-3 sm:grid-cols-2">
        <input required data-testid="notify-nom" placeholder="Nom / société" value={f.nom} onChange={(e) => setF({ ...f, nom: e.target.value })} className={inputCls} />
        <input required type="email" data-testid="notify-email" placeholder="E-mail" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={inputCls} />
        <input data-testid="notify-telephone" placeholder="Téléphone (facultatif)" value={f.telephone} onChange={(e) => setF({ ...f, telephone: e.target.value })} className={inputCls} />
        <select data-testid="notify-profil" value={f.profil} onChange={(e) => setF({ ...f, profil: e.target.value })} className={inputCls}>
          {NOTIFY_PROFILS.map((p) => <option key={p} value={p} className="bg-navy">{p}</option>)}
        </select>
      </div>
      <label className="mt-3 flex items-start gap-3 text-xs text-slate-400">
        <input type="checkbox" data-testid="notify-consent" checked={f.consentement} onChange={(e) => setF({ ...f, consentement: e.target.checked })} className="mt-0.5 accent-gold" />
        J'accepte d'être recontacté et informé de l'ouverture de l'application.
      </label>
      <button type="submit" disabled={busy} data-testid="notify-submit" className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-semibold text-navy transition-colors hover:bg-gold-light disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Me tenir informé"}
      </button>
    </form>
  );
}
